import React from 'react';
import { Row, Col, Card, Statistic, Table } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// Mock data
const resourceData = [
  { name: '10:00', cpu: 45, memory: 60, disk: 30 },
  { name: '10:05', cpu: 50, memory: 62, disk: 31 },
  { name: '10:10', cpu: 55, memory: 65, disk: 32 },
  { name: '10:15', cpu: 52, memory: 63, disk: 32 },
  { name: '10:20', cpu: 60, memory: 70, disk: 35 },
  { name: '10:25', cpu: 58, memory: 68, disk: 36 },
];

const alarmColumns = [
  { title: 'Time', dataIndex: 'time', key: 'time' },
  { title: 'Severity', dataIndex: 'severity', key: 'severity' },
  { title: 'Message', dataIndex: 'message', key: 'message' },
];

const alarmData = [
  { key: '1', time: '2025-11-10 10:21:03', severity: 'Critical', message: 'Node node-worker-01 is down.' },
  { key: '2', time: '2025-11-10 10:15:45', severity: 'Warning', message: 'Kafka message lag is over 10,000.' },
];

const DashboardPage = () => {
  return (
    <div>
      <Row gutter={16}>
        <Col span={6}>
          <Card>
            <Statistic
              title="Active Instances"
              value={1128}
              precision={0}
              valueStyle={{ color: '#3f8600' }}
              prefix={<ArrowUpOutlined />}
              suffix="%"
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Queued Tasks"
              value={93}
              precision={0}
              valueStyle={{ color: '#cf1322' }}
              prefix={<ArrowDownOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="Healthy Nodes" value={15} suffix="/ 16" />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="Kafka Lag" value={10520} />
          </Card>
        </Col>
      </Row>

      <Card title="Cluster Resource Usage (%)" style={{ marginTop: 16 }}>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={resourceData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="cpu" stroke="#8884d8" activeDot={{ r: 8 }} />
            <Line type="monotone" dataKey="memory" stroke="#82ca9d" />
            <Line type="monotone" dataKey="disk" stroke="#ffc658" />
          </LineChart>
        </ResponsiveContainer>
      </Card>

      <Card title="Recent System Alarms" style={{ marginTop: 16 }}>
        <Table columns={alarmColumns} dataSource={alarmData} pagination={false} />
      </Card>
    </div>
  );
};

export default DashboardPage;
